export const GET_HUBSPOT_DEALS = 'GET_HUBSPOT_DEALS';
export const GET_HUBSPOT_DEALS_SUCCESS = 'GET_HUBSPOT_DEALS_SUCCESS';
export const GET_HUBSPOT_DEALS_FAILURE = 'GET_HUBSPOT_DEALS_FAILURE';
